import * as React from "react";
import PropTypes from 'prop-types';

const SvgSuccessCheck = props => {
  if (props.id !== "_svgsuccesscheck") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path fillRule="evenodd" d="M32.5 5L15.45 22.488l-8.525-8.75-5.675 5.825 14.2 14.575 22.738-23.313z" /></svg>;
};

SvgSuccessCheck.displayName = "_svgsuccesscheck";
SvgSuccessCheck.propTypes = {
  id: PropTypes.string
};
SvgSuccessCheck.defaultProps = {
  id: ''
};
export default SvgSuccessCheck;